export const OnboardingStep = {
	NoMatch: 0,
	Step1IntroductionNotBooked: 1,
	Step2IntroductionBooked: 2,
	Step3IntroductionCompleted: 3,
	Step4VisitBooked: 4,
	Step5VisitPaid: 5,
	Step6VisitCompleted: 6,
	Step7RecurringVisitBooked: 7,
	Step8RecurringVisitPaid: 8,
	Step9RecurringVisitCompleted: 9
};

// Make the enum non-modifiable (optional)
Object.freeze(OnboardingStep);

export default OnboardingStep;
